import { HOME_EQUIPMENTS_CONTENT as homeEquipmentsContent } from './home-equipments.content';

export type HomeEquipmentsTabNode = 'intros' | 'history' | 'equipments';

export type HomeEquipmentsTab = {
    node: HomeEquipmentsTabNode;
    name: string;
};

export type HomeEquipmentsHistoryBreakpoint = {
    id: string;
    max: number;
    min?: number;
};

export type HomeEquipmentsHistoryItem = {
    readonly year: number;
    readonly content: readonly string[];
};

export type HomeEquipmentsEquipmentItem = {
    readonly image: string;
    readonly title: string;
    readonly text: readonly string[];
};

export type HomeEquipmentsEquipmentCategory = {
    readonly type: string;
    readonly desc: string;
    readonly content: readonly HomeEquipmentsEquipmentItem[];
};

export type HomeEquipmentsContent = {
    readonly intros: readonly string[];
    readonly history: readonly HomeEquipmentsHistoryItem[];
    readonly equipments: readonly HomeEquipmentsEquipmentCategory[];
};

export type HomeEquipmentsBreadcrumbNode = {
    name: string;
    url: string;
};

export const HOME_EQUIPMENTS_PAGE_URL = '/Home/Equipments';
export const HOME_EQUIPMENTS_BANNER_IMAGE_URL =
    '/Content/doc/cht/about_gainhow/DSC_0447 1.png';
export const HOME_EQUIPMENTS_GENERAL_MANAGER_AVATAR_IMAGE_URL =
    '/Content/doc/cht/about_gainhow/5ad1246af87cb07947fd4c1a29a5f289.png';
export const HOME_EQUIPMENTS_GENERAL_MANAGER_SIGNATURE_IMAGE_URL =
    '/Content/doc/cht/about_gainhow/8b38c7992621dea5803d12602b2177b4.png';
export const HOME_EQUIPMENTS_GENERAL_MANAGER_TITLE = '總經理 張訓嘉';

export const HOME_EQUIPMENTS_TABS: HomeEquipmentsTab[] = [
    {
        node: 'intros',
        name: '經營理念',
    },
    {
        node: 'history',
        name: '公司沿革',
    },
    {
        node: 'equipments',
        name: '廠房設備',
    },
];

export const HOME_EQUIPMENTS_HISTORY_BREAKPOINTS: HomeEquipmentsHistoryBreakpoint[] =
    [
        {
            id: '107~99',
            max: 107,
            min: 99,
        },
        {
            id: '98~97',
            max: 98,
            min: 97,
        },
        {
            id: '96~95',
            max: 96,
            min: 95,
        },
        {
            id: '94~93',
            max: 94,
            min: 93,
        },
        {
            id: '92~',
            max: 92,
        },
    ];

export const HOME_EQUIPMENTS_DEFAULT_ACTIVE_TAB: HomeEquipmentsTabNode =
    'intros';
export const HOME_EQUIPMENTS_DEFAULT_BREAKPOINT_ID = '107~99';
export const HOME_EQUIPMENTS_DEFAULT_EQUIPMENT_TYPE = '印前設備';

export const HOME_EQUIPMENTS_CONTENT: HomeEquipmentsContent =
    homeEquipmentsContent;

export const isHomeEquipmentsTabNode = (
    value: string
): value is HomeEquipmentsTabNode => {
    return HOME_EQUIPMENTS_TABS.some((tab) => tab.node === value);
};

export const resolveHomeEquipmentsTab = (
    node: string
): HomeEquipmentsTab | undefined => {
    return HOME_EQUIPMENTS_TABS.find((tab) => tab.node === node);
};

export const resolveHomeEquipmentsActiveName = (node: string): string => {
    return resolveHomeEquipmentsTab(node)?.name || HOME_EQUIPMENTS_TABS[0].name;
};

export const buildHomeEquipmentsBreadcrumbNodeList = (
    node: HomeEquipmentsTabNode
): HomeEquipmentsBreadcrumbNode[] => {
    return [
        {
            name: resolveHomeEquipmentsActiveName(node),
            url: `${HOME_EQUIPMENTS_PAGE_URL}#${node}`,
        },
    ];
};

export const filterHomeEquipmentsHistoryContent = (
    breakpointId: string
): readonly HomeEquipmentsHistoryItem[] => {
    const breakpoint = HOME_EQUIPMENTS_HISTORY_BREAKPOINTS.find(
        (item) => item.id === breakpointId
    );
    if (!breakpoint) {
        return [];
    }

    return HOME_EQUIPMENTS_CONTENT.history.filter((item) => {
        const isAfterMin =
            breakpoint.min === undefined || item.year >= breakpoint.min;
        const isBeforeMax =
            breakpoint.max === undefined || item.year <= breakpoint.max;

        return isAfterMin && isBeforeMax;
    });
};

export const resolveHomeEquipmentCategory = (
    type: string
): HomeEquipmentsEquipmentCategory | undefined => {
    return HOME_EQUIPMENTS_CONTENT.equipments.find(
        (item) => item.type === type
    );
};

export const resolveHomeEquipmentDescription = (type: string): string => {
    return resolveHomeEquipmentCategory(type)?.desc || '';
};

export const resolveHomeEquipmentContent = (
    type: string
): readonly HomeEquipmentsEquipmentItem[] => {
    return resolveHomeEquipmentCategory(type)?.content || [];
};

export const buildHomeEquipmentImageUrl = (
    type: string,
    image: string
): string => {
    return `/Content/doc/cht/about_gainhow/${type}/${image}`;
};
